import { render, staticRenderFns } from "./FormNotification.vue?vue&type=template&id=06ad82f3&scoped=true&"
import script from "./FormNotification.vue?vue&type=script&lang=js&"
export * from "./FormNotification.vue?vue&type=script&lang=js&"
import style0 from "./FormNotification.vue?vue&type=style&index=0&id=06ad82f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad82f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ad82f3')) {
      api.createRecord('06ad82f3', component.options)
    } else {
      api.reload('06ad82f3', component.options)
    }
    module.hot.accept("./FormNotification.vue?vue&type=template&id=06ad82f3&scoped=true&", function () {
      api.rerender('06ad82f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/FormNotification.vue"
export default component.exports